// To show localized time if needed along side the source time
function localizeTimes(root) {
  // Check if the element has the data attribute
  root.querySelectorAll("[data-board-localize-time]").forEach((el) => {
    if (!el.dataset.timestamp) return;
    if (!el.dataset.timeTarget) return;
    // Already converted (a later update of the page only adds new elements)
    if (el.dataset.boardLocalized) return;
    el.dataset.boardLocalized = "1";

    const timestamp = el.dataset.timestamp;

    const timeTargetElement = el.querySelector(el.dataset.timeTarget);
    const timeSourceTargetElement = el.dataset.timeSourceTarget
      ? el.querySelector(el.dataset.timeSourceTarget)
      : null;
    const timeZoneTargetElement = el.dataset.timezoneTarget
      ? el.querySelector(el.dataset.timezoneTarget)
      : null;

    // Build localized time string
    const date = new Date(timestamp * 1000);
    // Get current language from html tag
    const lang = document.documentElement.lang;
    // Get localized only time string
    const options = {
      hour: "numeric",
      minute: "2-digit",
    };
    const timeString = date.toLocaleTimeString(lang, options);

    // Timezone name and offset on the event date, not today, so a DST change in between is respected
    const parts = new Intl.DateTimeFormat(navigator.language, {
      timeZoneName: "short",
    }).formatToParts(date);
    const timeZoneName = parts.find((p) => p.type === "timeZoneName").value;

    // Check if the timezone is the same as the user one and avoid duplication of times
    if (el.dataset.timezoneOffset) {
      const sourceTimeZoneOffset = parseInt(el.dataset.timezoneOffset);
      if (!isNaN(sourceTimeZoneOffset)) {
        let currentTimezoneOffset = date.getTimezoneOffset();
        // Convert into seconds and switch sign
        // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset#negative_values_and_positive_values
        currentTimezoneOffset = -(currentTimezoneOffset * 60);
        if (sourceTimeZoneOffset == currentTimezoneOffset) {
          // Hide localized time
          if (timeZoneTargetElement) timeZoneTargetElement.remove();
          if (timeTargetElement) timeTargetElement.remove();
        }
      }
    }

    // TODO: Improve all this because timeTargetElement can be removed
    // If there is also a specific timezone target
    if (timeZoneTargetElement) {
      // Set localized time string and timezone string
      if (timeTargetElement) timeTargetElement.innerHTML = timeString;
      timeZoneTargetElement.innerHTML = timeZoneName;
    } else if (timeTargetElement) {
      timeTargetElement.innerHTML = `${timeString} ${timeZoneName}`;
    }

    // Replace the source time if needed
    if (timeSourceTargetElement && el.dataset.timeSourceContent) {
      timeSourceTargetElement.innerHTML = el.dataset.timeSourceContent;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  localizeTimes(document);
});

// Archive search, filters and pagination replace the results in place (archive-taxonomy-filters realtime.js)
document.addEventListener("board:archive-updated", function (event) {
  localizeTimes(event.target);
});
